module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.files2 != null && _vm.files2.length > 0) ? _c('div', {
    staticClass: "m-b-10"
  }, [_c('draggable', {
    on: {
      "change": _vm.orderChanged
    },
    model: {
      value: (_vm.files2),
      callback: function($$v) {
        _vm.files2 = $$v
      },
      expression: "files2"
    }
  }, _vm._l((_vm.files2), function(f, _f) {
    return _c('div', [_c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: ('/image/2/' + f.filename),
        expression: "'/image/2/' + f.filename"
      }]
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(_f)
        }
      }
    }, [_vm._v("x")])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('vue-clip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.maxFiles == 0 || (_vm.files2.length < _vm.maxFiles))),
      expression: "(maxFiles == 0 || (files2.length < maxFiles))"
    }],
    attrs: {
      "options": _vm.options,
      "on-complete": _vm.complete
    },
    scopedSlots: _vm._u([{
      key: "clip-uploader-action",
      fn: function(params) {
        return [_c('div', {
          staticClass: "upload-action upload-action-well",
          class: {
            'is-dragging': params.dragging
          }
        }, [_c('div', {
          staticClass: "dz-message"
        }, [_c('h2', [_c('span', {
          staticClass: "icon-upload icon-white"
        }), _vm._v(" " + _vm._s(_vm.uploadText))])])])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-734a8fca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Content/Modern/js/vue/_uploader.vue
// module id = 119
// module chunks = 1